import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MergeOrganisationRefdata, WarehouseLicense} from '@portbase/bezoekschip-service-typescriptmodels';
import {QueryGateway} from '../../../common/query-gateway';
import {PortvisitUtils} from '../../../refdata/portvisit-utils';
import {checkValidity, removeItem, sendCommand, sendQuery} from '../../../common/utils';
import {AppContext} from '../../../app-context';
import {WarehouseLicenseComponent} from '../common/warehouse-license/warehouse-license.component';

@Component({
    selector: 'app-license-book',
    templateUrl: './license-book.component.html',
    styleUrls: ['./license-book.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LicenseBookComponent implements OnInit {
  utils = PortvisitUtils;
  values : WarehouseLicense[] = [];

  constructor(private queryGateway : QueryGateway) {
  }

  ngOnInit(): void {
    sendQuery("com.portbase.bezoekschip.common.api.cargo.FindMyWarehouseLicenses", {term: '', maxHits: 10000})
      .subscribe(values => this.values = values);
  }

  add() {
    this.values.splice(0, 0, <any>{});
  }

  remove(value) {
    return () => {
      removeItem(this.values, value);

      if (value.id) {
        sendCommand('com.portbase.bezoekschip.common.api.refdata.MergeWarehouseLicense', <MergeOrganisationRefdata>{
          value: value,
          id: value.id,
          delete: true
        }, () => {
          AppContext.registerSuccess("License was deleted successfully");
          this.queryGateway.removeFromCache("com.portbase.bezoekschip.common.api.cargo.FindMyWarehouseLicenses");
        });
      }
    }
  }

  save(value : WarehouseLicenseComponent) {
    return checkValidity(value.elementRef);
  }

  onSaved() {
    AppContext.registerSuccess("License was saved successfully");
  }
}
